
const SUPPORTED_LOCALES = ["el", "en", "ru", "sr", "ro", "bg", "mk"] as const;

function localeFromPathname(): string {
  if (typeof window === "undefined") return "el";
  const first = window.location.pathname.split("/").filter(Boolean)[0];
  return SUPPORTED_LOCALES.includes(first as any) ? first : "el";
}

const API_BASE = (process.env.REACT_APP_API_BASE || "https://www.ritasproperties.com").replace(/\/$/, "");

export async function listPropertiesPaged(params: any) {
  const qs = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    qs.set(k, String(v));
  });

  // ✅ ADD THIS
  qs.set("lang", localeFromPathname());

  const url = `${API_BASE}/api/properties?${qs.toString()}`;
  console.log("listPropertiesPaged:", url);

  const res = await fetch(url);
  if (!res.ok) throw new Error(`Failed ${res.status}`);
  return res.json();
}

export async function getPropertyBySlug(slug: string) {
  const lang = localeFromPathname();
  const url = `${API_BASE}/api/properties/${encodeURIComponent(slug)}?lang=${lang}`;
  const res = await fetch(url);
  if (!res.ok) return null;
  return res.json();
}

